import React, {useEffect, useState} from "react";
import axios from "axios";
import {GET_RESTAURANTS_SLIDES_URL} from "../../configs";
import Ink from "react-ink";
import {useNavigate} from "react-router-dom";
import { Drawer } from "vaul";


export default function CategorySlider() {
    const [data, setData] = useState(null);
    const navigate = useNavigate();
    const [openMore, setOpenMore] = useState(false);


    useEffect(() => {
        if (data) return;
        getAllRestaurantSliders();
    }, []);

    const getAllRestaurantSliders = () => {
        axios.post(GET_RESTAURANTS_SLIDES_URL)
            .then((response) => {
                if (response?.data) {
                    setData(response?.data);
                }
            });
    };

    useEffect(() => {
        if (openMore) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        // Cleanup in case component unmounts
        return () => {
            document.body.style.overflow = "";
        };
    }, [openMore]);

    const openDrawer = () => {
        setOpenMore(true);
        window.history.pushState({ modalOpen: true }, "");
    };

// Listen for back button
    useEffect(() => {
        const handlePopState = (event) => {
            // If modal is open, close it instead of going back
            if (openMore) {
                setOpenMore(false);
            }
        };

        window.addEventListener("popstate", handlePopState);

        return () => window.removeEventListener("popstate", handlePopState);
    }, [openMore]);


    const changeRouteToRestaurantsCategories = (categories) => {
        if (categories?.categories_ids) {
            const saveCategorySelectOptions = new Promise((resolve) => {
                localStorage.setItem("categorySelectOptions", JSON.stringify(categories.categories_ids));
                resolve("categorySelectOptions Saved");
            });
            saveCategorySelectOptions.then(() => {
                navigate("categories/stores");
            });
        }
    };



    return (
        <>
            {data?.length > 0 && (
                <>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "20px 0px 0px 15px",
                        }}
                    >
                        <div
                            style={{
                                margin: 0,
                                fontSize: "1.2rem",
                                fontWeight: 550,
                                color: "#303030",
                                fontFamily: "'Inter', sans-serif",
                                textShadow: "0.5px 0.5px 0.5px rgba(0,0,0,0.1)", // 👈 text shadow
                            }}
                        >
                            Find something tasty
                        </div>
                    </div>


                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                            columnGap: "3px",
                            rowGap: "8px",
                            overflowX: "hidden",
                        }}
                    >
                    {data?.slice(0, 7)?.map((category) => (
                            <div style={{
                                margin: 2,
                                padding: 3,
                                // backgroundColor: "red",
                                position: "relative",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                minWidth: 0,
                            }}
                                 onClick={() => {
                                     changeRouteToRestaurantsCategories(category);
                                 }}
                            >
                                <img
                                    src={"https://food.totalfresh.co"+category?.image}
                                    // src="https://www.shutterstock.com/image-photo/side-view-isometric-angle-crispy-600nw-2600398075.jpg"
                                    alt={category.name}
                                    style={{
                                        width: "100%",
                                        aspectRatio: "1 / 1",
                                        objectFit: "cover",
                                        borderRadius: 50,
                                        flexShrink: 0,
                                    }}
                                />

                                <span
                                    style={{
                                        color: "#636363",
                                        backgroundColor: "transparent",
                                        fontSize: "0.9rem",
                                        fontFamily: "'Inter',sans-serif",
                                        fontWeight: 600,

                                        width: "100%",
                                        minWidth: 0,

                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        textAlign: "center",
                                        display: "block",
                                    }}
                                    title={category.name}
                                >
                                {category.name}
                            </span>

                                <Ink duration="500" hasTouch={true}/>
                            </div>
                        ))}
                        <div style={{
                            margin: 2,
                            padding: 3,
                            position: "relative",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            minWidth: 0,
                            opacity: openMore ? 0.5 : 1
                        }}
                             onClick={openDrawer}
                        >
                            <div style={{
                                width: "100%",
                                aspectRatio: "1 / 1",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                <div style={{
                                    backgroundColor: "#c5eab5",
                                    alignItems: "center",
                                    width: "70%",
                                    aspectRatio: "1 / 1",
                                    justifyContent: "center",
                                    display: "flex",
                                    borderRadius: 50,
                                }}>
                                    <img
                                        // src={"https://food.totalfresh.co"+category?.image}
                                        src={require("../../assets/food-tray.png")}
                                        alt={"More"}
                                        style={{
                                            width: "30px",
                                            height: "30px",
                                            objectFit: "cover",
                                            borderRadius: 50,
                                            flexShrink: 0,
                                        }}
                                    />
                                </div>
                            </div>

                            <span
                                style={{
                                    color: "#5ba53e",
                                    backgroundColor: "transparent",
                                    fontSize: "0.9rem",
                                    fontFamily: "'Inter',sans-serif",
                                    fontWeight: 600,

                                    width: "100%",
                                    minWidth: 0,

                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    textAlign: "center",
                                    display: "block",
                                }}
                                title={"More"}
                            >
                                More
                            </span>

                        </div>
                    </div>

                </>
            )}

            <Drawer.Root open={openMore} onOpenChange={setOpenMore} onClose={() => setOpenMore(false)} closeOnEsc>
                <Drawer.Portal>
                    <Drawer.Overlay
                        style={{
                            backgroundColor: "rgba(0,0,0,0.4)",
                            position: "fixed",
                            inset: 0,
                            zIndex: 3000,
                        }}
                    />

                    <Drawer.Content
                        style={{
                            backgroundColor: "#fff",
                            borderTopLeftRadius: 16,
                            borderTopRightRadius: 16,
                            position: "fixed",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            maxHeight: "90vh",
                            padding: 16,
                            zIndex: 3001,
                        }}
                    >
                        {/* Handle */}
                        <div
                            style={{
                                width: 40,
                                height: 4,
                                backgroundColor: "#ccc",
                                borderRadius: 2,
                                margin: "0 auto 12px",
                            }}
                        />

                        <Drawer.Title
                            style={{
                                fontSize: "1.1rem",
                                fontWeight: 700,
                                fontFamily:  "'Inter'",
                                marginBottom: 12,
                            }}
                        >
                            All Categories
                        </Drawer.Title>

                        {/* Categories grid inside drawer */}
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                                gap: 8,
                                overflowY: "auto",
                            }}
                        >
                            {data?.map((category) => (
                                <div
                                    key={category.id}
                                    style={{
                                        // display: "flex",
                                        // flexDirection: "column",
                                        // alignItems: "center",
                                        cursor: "pointer",
                                        // margin: 2,
                                        // padding: 3,
                                        // backgroundColor: "red",
                                        position: "relative",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        minWidth: 0,
                                    }}
                                    onClick={() => {
                                        setOpenMore(false);
                                        changeRouteToRestaurantsCategories(category);
                                    }}
                                >
                                    <img
                                        src={"https://food.totalfresh.co"+category?.image}
                                        alt={category.name}
                                        style={{
                                            width: "100%",
                                            aspectRatio: "1 / 1",
                                            borderRadius: 50,
                                            objectFit: "cover",
                                        }}
                                    />
                                    <div
                                        style={{
                                            marginTop: 4,
                                            fontSize: "1rem",
                                            textAlign: "center",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            width: "100%",
                                        }}
                                    >
                                        {category.name}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Drawer.Content>
                </Drawer.Portal>
            </Drawer.Root>

        </>
    )

}